module.exports = __webpack_public_path__ + "static/media/30a Open Guard.1cffffae.jpg";